import { render, staticRenderFns } from "./WizardContent.vue?vue&type=template&id=24d5a194&scoped=true&"
import script from "./WizardContent.vue?vue&type=script&lang=ts&"
export * from "./WizardContent.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContent.vue?vue&type=style&index=0&id=24d5a194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5a194",
  null
  
)

export default component.exports